var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_310_4461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75606 10.0747C3.07212 8.60961 4.15224 5.84143 6.38435 5.90185L18.9341 6.24124C20.8946 6.29433 21.9522 8.56235 20.7327 10.0984L12.9263 19.931C11.5377 21.6794 8.72253 20.7268 8.68261 18.4952L8.61 14.469C8.6086 14.3914 8.60375 14.3143 8.5949 14.2379L12.2803 12.5194C12.6556 12.3443 12.8181 11.898 12.6431 11.5227C12.468 11.1474 12.0217 10.985 11.6464 11.1599L7.96098 12.8784C7.90815 12.8226 7.8522 12.7693 7.79365 12.7183L4.75606 10.0747ZM5.24205 16.3531C5.6173 16.1781 6.06355 16.3407 6.23874 16.7158C6.41379 17.0912 6.25136 17.5375 5.87598 17.7125L4.06336 18.5578C3.68796 18.7328 3.24172 18.5704 3.06667 18.195C2.89195 17.8197 3.05418 17.3733 3.42943 17.1983L5.24205 16.3531ZM3.55069 12.7282C3.92601 12.5532 4.37224 12.7158 4.54739 13.091C4.72244 13.4664 4.56002 13.9126 4.18462 14.0877L2.372 14.9329C1.9966 15.108 1.55036 14.9456 1.37531 14.5702C1.20046 14.1948 1.36276 13.7485 1.73808 13.5735L3.55069 12.7282Z",
    fill: "#548CD2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_310_4461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.1ab9dd5a231b115c881f4ad88832dc6c.svg";
export { ForwardRef as ReactComponent };